import React from 'react';
import classNames from 'classnames';
import { CtaSigninSection } from './utils';

const ctaGridClasses = classNames(
    'eds-g-cell',
    'eds-g-cell-12-12',
    'eds-g-offset-0-12',
    'eds-g-cell-md-10-12',
    'eds-g-offset-md-1-12',
    'eds-l-pad-vert-4',
    'eds-l-md-pad-vert-10',
    'eds-l-lg-pad-vert-10',
    'eds-l-sm-pad-vert-4',
);
const signupGridClasses = classNames(
    'eds-g-cell',
    'eds-g-cell-1-1',
    'eds-g-cell-ln-1-3',
    'eds-g-cell-lg-1-3',
    'eds-l-mar-top-3',
    'eds-l-pad-hor-1',
);
interface CallToActionModuleProps {
    headline: string;
    shouldIncludeSigninFields: boolean;
    buttonText: string;
}

const CallToActionModule = ({
    headline,
    shouldIncludeSigninFields,
    buttonText,
}: CallToActionModuleProps) => (
    <section>
        <div className="mktg-grid-container cta-module">
            <div className={ctaGridClasses}>
                <div className="eds-l-pad-all-10">
                    <div className="eds-l-pad-hor-2">
                        <p className="eds-text-bl eds-text-color--grey-900 eds-text--center eds-l-mar-bot-4">
                            {headline}
                        </p>
                    </div>
                    <CtaSigninSection
                        shouldIncludeSigninFields={shouldIncludeSigninFields}
                        buttonText={buttonText}
                        signupGridClasses={signupGridClasses}
                        showMktgFormClass={true}
                    />
                </div>
            </div>
        </div>
    </section>
);

export default CallToActionModule;
